<template>
  <div>
    <v-data-table
      :mobile-breakpoint="0"
      :headers="headers"
      :items="templates"
      :loading="loading"
      class="elevation-1 mt-6"
      :footer-props="{ 'items-per-page-options': [10, 25, 50] }"
    >
      <template v-slot:item.eventName="{ item }">
        <v-chip small color="primary" text-color="white">
          {{ formatEventName(item.eventName) }}
        </v-chip>
      </template>
      
      <template v-slot:item.variables="{ item }">
        <span>{{ item.variables ? item.variables.join(', ') : '-' }}</span>
      </template>

      <template v-slot:item.active="{ item }">
        <v-icon v-if="item.active" color="success">mdi-check-circle</v-icon>
        <v-icon v-else color="grey">mdi-close-circle</v-icon>
      </template>
      
      <template v-slot:item.actions="{ item }">
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="primary"
              v-bind="attrs"
              v-on="on"
              @click="editTemplate(item)"
            >
              <v-icon small>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>Edit</span>
        </v-tooltip>
        
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              icon
              small
              color="error"
              v-bind="attrs"
              v-on="on"
              @click="confirmDelete(item)"
            >
              <v-icon small>mdi-delete</v-icon>
            </v-btn>
          </template>
          <span>Delete</span>
        </v-tooltip>
      </template>
    </v-data-table>

    <!-- Delete Confirmation Dialog -->
    <v-dialog v-model="deleteDialog" max-width="400">
      <v-card>
        <v-card-title class="text-h6">Confirm Delete</v-card-title>
        <v-card-text>
          Are you sure you want to delete the template for event "{{ selectedTemplate ? formatEventName(selectedTemplate.eventName) : '' }}"?
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="deleteDialog = false">Cancel</v-btn>
          <v-btn color="error" text @click="deleteTemplate" :loading="deleteLoading">Delete</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="3000" top right>
      {{ snackbarText }}
    </v-snackbar>
  </div>
</template>

<script>
export default {
  props: {
    templates: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      headers: [
        { text: 'Event Name', value: 'eventName', sortable: true },
        { text: 'Template Name', value: 'templateName', sortable: false },
        { text: 'No. of Variables', value: 'variableCount', sortable: false, align: 'center' },
        { text: 'Variable Names', value: 'variables', sortable: false },
        { text: 'Status', value: 'active', sortable: false, align: 'center' },
        { text: 'Actions', value: 'actions', sortable: false, align: 'center' }
      ],
      deleteDialog: false,
      selectedTemplate: null,
      deleteLoading: false,
      snackbar: false,
      snackbarText: '',
      snackbarColor: 'success'
    };
  },
  methods: {
    formatEventName(eventName) {
      return eventName.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
    },
    editTemplate(template) {
      this.$emit('edit-template', template);
    },
    confirmDelete(template) {
      this.selectedTemplate = template;
      this.deleteDialog = true;
    },
    deleteTemplate() {
      this.deleteLoading = true;
      this.$apollo
        .mutate({
          mutation: require('../api/deleteGallaboxTemplate.graphql'),
          variables: {
            id: this.selectedTemplate._id
          }
        })
        .then(() => {
          this.snackbarText = 'Template deleted successfully';
          this.snackbarColor = 'success';
          this.snackbar = true;
          this.deleteDialog = false;
          this.deleteLoading = false;
          this.$emit('template-deleted');
        })
        .catch(error => {
          this.snackbarText = error.message || 'Failed to delete template';
          this.snackbarColor = 'error';
          this.snackbar = true;
          this.deleteLoading = false;
        });
    }
  }
};
</script>

